(function () {
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product gallery
  var mainImg = document.querySelector('[data-gallery-main] img');
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!mainImg) return;
      mainImg.src = btn.getAttribute('data-src');
      mainImg.srcset = '';
      document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', 'false');
      });
      btn.setAttribute('aria-current', 'true');
    });
  });

  // Buy box: quantity x delivery matrix
  var buybox = document.querySelector('[data-buybox]');
  var offersEl = document.querySelector('[data-offers-json]');
  var offers = [];
  try { offers = offersEl ? JSON.parse(offersEl.textContent) : []; } catch (e) { offers = []; }
  var state = { qty: 0, sub: false, planId: null };

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function currentOffer() { return offers[state.qty]; }
  function preferredPlan(o) {
    if (!o || !o.plans.length) return null;
    var m = (o.meta || '').match(/(\d+)-day supply/);
    if (m) {
      var hit = o.plans.find(function (p) { return p.name.indexOf(m[1]) !== -1; });
      if (hit) return hit;
    }
    return o.plans[0];
  }

  function currentPlan() {
    var o = currentOffer();
    if (!o || !state.sub || !o.plans.length) return null;
    return o.plans.find(function (p) { return p.id === state.planId; }) || o.plans[0];
  }
  function currentPrice() {
    var plan = currentPlan();
    return plan ? plan.price : (currentOffer() ? currentOffer().price : 0);
  }

  function renderQty() {
    var wrap = document.querySelector('[data-qty-group]');
    if (!wrap) return;
    wrap.innerHTML = '';
    offers.forEach(function (o, i) {
      var label = document.createElement('label');
      label.className = 'plan' + (i === state.qty ? ' is-selected' : '');
      var compare = o.compare > o.price ? '<s style="color:var(--muted);font-weight:400">' + money(o.compare) + '</s> ' : '';
      label.innerHTML = '<input type="radio" name="qty"' + (i === state.qty ? ' checked' : '') + '>' +
        '<span class="plan__body"><span class="plan__title">' + o.title +
        (o.badge ? '<span class="plan__badge">' + o.badge + '</span>' : '') + '</span>' +
        '<span class="plan__meta">' + o.meta + '</span></span>' +
        '<span class="plan__price">' + compare + money(o.price) + '</span>';
      label.querySelector('input').addEventListener('change', function () {
        state.qty = i;
        var pp = preferredPlan(offers[i]);
        if (pp) state.planId = pp.id;
        sync();
      });
      wrap.appendChild(label);
    });
  }

  function sync() {
    var o = currentOffer();
    if (!o) return;
    var subOpt = document.querySelector('[data-ptype-sub]');
    var otOpt = document.querySelector('[data-ptype-onetime]');
    var freqWrap = document.querySelector('[data-freq-wrap]');
    var hasPlans = o.plans.length > 0;
    if (subOpt) subOpt.hidden = !hasPlans;
    if (!hasPlans) state.sub = false;
    if (state.sub && hasPlans) {
      var plan = currentPlan(); state.planId = plan.id;
    }
    if (otOpt) {
      otOpt.querySelector('input').checked = !state.sub;
      otOpt.classList.toggle('is-selected', !state.sub);
      var otp = otOpt.querySelector('[data-ot-price]');
      if (otp) otp.textContent = money(o.price);
    }
    if (subOpt && hasPlans) {
      var best = o.plans[0];
      subOpt.querySelector('input').checked = state.sub;
      subOpt.classList.toggle('is-selected', state.sub);
      var sp = subOpt.querySelector('[data-sub-price]');
      var pct = subOpt.querySelector('[data-sub-pct]');
      var planNow = state.sub ? currentPlan() : best;
      if (sp) sp.textContent = money(planNow.price);
      if (pct) {
        var savings = Math.round((1 - planNow.price / o.price) * 100);
        pct.textContent = savings > 0 ? savings + '%' : '';
      }
    }
    if (freqWrap) {
      freqWrap.hidden = !(state.sub && hasPlans);
      if (state.sub && hasPlans) {
        var sel = freqWrap.querySelector('[data-freq]');
        sel.innerHTML = '';
        o.plans.forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = p.id; opt.textContent = p.name;
          if (p.id === state.planId) opt.selected = true;
          sel.appendChild(opt);
        });
      }
    }
    renderQty();
    var priceEls = document.querySelectorAll('[data-selected-price]');
    var nameEls = document.querySelectorAll('[data-selected-name]');
    priceEls.forEach(function (el) { el.textContent = money(currentPrice()); });
    nameEls.forEach(function (el) {
      el.textContent = o.title + (state.sub ? ' · Subscribe & save' : '');
    });
  }

  var otInput = document.querySelector('[data-ptype-onetime] input');
  var subInput = document.querySelector('[data-ptype-sub] input');
  if (otInput) otInput.addEventListener('change', function () { state.sub = false; sync(); });
  if (subInput) subInput.addEventListener('change', function () { state.sub = true; sync(); });
  var freqSel = document.querySelector('[data-freq]');
  if (freqSel) freqSel.addEventListener('change', function () { state.planId = Number(freqSel.value); sync(); });

  if (offers.length) {
    // default: subscribe pre-selected when the first offer has plans
    if (offers[0].plans.length) { state.sub = true; state.planId = preferredPlan(offers[0]).id; }
    sync();
  }

  function addSelectedToCart(button) {
    var o = currentOffer();
    if (!o) return;
    var payload = { items: [{ id: o.variant, quantity: 1 }] };
    var plan = currentPlan();
    if (plan) payload.items[0].selling_plan = plan.id;
    button.disabled = true;
    var original = button.textContent;
    button.textContent = 'Adding\u2026';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/cart';
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = original;
        alert('Something went wrong adding to cart. Try again.');
      });
  }
  document.querySelectorAll('[data-add-selected]').forEach(function (btn) {
    btn.addEventListener('click', function () { addSelectedToCart(btn); });
  });

  // Recommended combo: last offer (bundle), 45-day plan when available
  function resolveRecommended() {
    if (!offers.length) return null;
    var i = offers.length - 1;
    var o = offers[i];
    var plan = preferredPlan(o);
    return { qty: i, plan: plan, offer: o };
  }
  var recoBtns = document.querySelectorAll('[data-add-recommended]');
  if (recoBtns.length) {
    var reco = resolveRecommended();
    if (reco) {
      var priceEl = document.querySelector('[data-reco-price]');
      var compareEl = document.querySelector('[data-reco-compare]');
      var recoPrice = reco.plan ? reco.plan.price : reco.offer.price;
      if (priceEl) priceEl.textContent = money(recoPrice);
      if (compareEl && reco.plan && reco.offer.price > recoPrice) compareEl.textContent = money(reco.offer.price);
      recoBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.qty = reco.qty;
          state.sub = !!reco.plan;
          if (reco.plan) state.planId = reco.plan.id;
          sync();
          addSelectedToCart(btn);
        });
      });
    }
  }

  // Sticky add-to-cart bar
  var sticky = document.querySelector('[data-sticky-atc]');
  if (sticky && buybox) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(buybox);
  }
})();
